import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private router: Router) { }

  public login() {
    window.location.assign('/auth/login?returnUrl='+ this.router.url);
  }

  public logout() {
    window.location.assign('/auth/logout');
  }
}
